/* eslint-disable camelcase */
import {
    ArrowLeftCircle,
    AutoRenewIcon,
    Button,
    Flex,
    Heading,
    IconSort,
    Link,
    ModalV2,
    TagPriceActiveFullWidth,
    Text,
    useMatchBreakpoints,
    useModal,
    useToast,
} from '@pancakeswap/uikit'
import BigNumber from 'bignumber.js'
import ConnectWalletButton from 'components/ConnectWalletButton'
import Container from 'components/Layout/Container'
import PageFullWidth from 'components/Layout/PageFullWidth'
import { KEY_LOGIN, UNIT_TOKEN } from 'config'
import { BrandApi } from 'config/api/brand'
import contracts from 'config/constants/contracts'
import { getToken } from 'config/giftcards'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import useTheme from 'hooks/useTheme'

import { ToastDescriptionWithTx } from 'components/Toast'
import jwt_decode from 'jwt-decode'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'state'
import { GetDataGiftCards } from 'state/giftCards'
import { fetchBuyVouchers, fetchIsUpdateOrder, fetchStatusScreen } from 'state/giftCards/actions'
import styled from 'styled-components'
import 'swiper/css'
import { getAddress } from 'utils/addressHelpers'
import { formatNumberv2 } from 'utils/formatNumber'
import { getChainName } from 'utils/getChainName'
import ModalPaymentOnus from './components/ModalPaymentOnus'
import { useApprove } from './hook/useApprove'
import { useBuyVouchers } from './hook/useBuyVoucher'
import {
    Card,
    CsButtonContinue,
    CsFlexCard,
    CsFlexLine,
    CsGiftCardInfoMobile,
    CsGiftCardInfoPC,
    CsHeading,
    CsSubHeading,
    CsTagPrice,
    CsWrapInfo,
    Hr,
    RowItem,
    RowItemHeading,
} from './styles'

const OrderSummary = () => {
    const { account, chainId, provider } = useActiveWeb3React()
    const dispatch = useDispatch<AppDispatch>()
    const { theme } = useTheme()
    const { isMobile } = useMatchBreakpoints()
    const router = useRouter()
    const [pendingBuyVoucher, setPendingBuyVoucher] = useState(false)

    const contractAddress = getAddress(contracts.buyVouchers, chainId)
    // UseCoreDataUser(contractAddress, account, token, chainId)
    // useEffect(() => {
    //     (async() => {
    //         const listTokenByTypeChain = listTokenGetBalance(chainId)
    //         const resListBalance = await fetchBalanceByChain(account, listTokenByTypeChain )
    //         await dispatch(fetchDataUserByChain(resListBalance))
    //     })()
    // },[account, chainId, dispatch])

    const dataGiftcards = GetDataGiftCards()
    const { dataVouchers, isLoading } = dataGiftcards
    const { dataUser, ListBalance, tokenSupport } = dataGiftcards

    const handleBack = (newValue: number) => {
        dispatch(fetchStatusScreen({ isActiveScreen: newValue }))
    }
    const dataLocalStorage = localStorage?.getItem(KEY_LOGIN)
    useEffect(() => {
        (async () => {
            const tokenLocalStorage = dataLocalStorage
            const decoded: any = await jwt_decode(!tokenLocalStorage ? '' : tokenLocalStorage)
            if (account?.length === decoded?.sub?.length && account?.toLowerCase() !== decoded?.sub?.toLowerCase()) {
                localStorage.removeItem(KEY_LOGIN)
                dispatch(fetchStatusScreen({ isActiveScreen: 0 }))
                dispatch(fetchIsUpdateOrder({ isUpdate: true }))
                router?.push('/order')
            }
        })()
    }, [account, dataLocalStorage, dispatch, router])
    const findTokenPayment = useMemo(() => {
        return tokenSupport.find(
            (dt) => dt?.token?.address?.toLowerCase() === dataVouchers?.tokenPayment?.toLowerCase(),
        )
    }, [tokenSupport, dataVouchers?.tokenPayment])
    const checkPrice = dataVouchers?.isPromo === 2 ? dataVouchers?.promoPrice : dataVouchers?.price
    const totalPrice = new BigNumber(dataVouchers?.fillAmount)?.multipliedBy(checkPrice)?.toString()
    const { toastSuccess, toastError } = useToast()

    const { handleApprove, pendingTx } = useApprove(
        contractAddress,
        account,
        findTokenPayment?.token,
        chainId,
        provider,
    )

    const isNotBanlance = useMemo(() => {
        if (new BigNumber(dataUser?.balanceOf).isLessThan(findTokenPayment?.exchangeRate)) return !false
        return false
    }, [dataUser?.balanceOf, findTokenPayment?.exchangeRate])

    const isNotAllowance = useMemo(() => {
        if (new BigNumber(dataUser?.allowance).isLessThan(findTokenPayment?.exchangeRate)) return !false
        return false
    }, [dataUser?.allowance, findTokenPayment?.exchangeRate])

    const fillAmount = new BigNumber(dataVouchers?.fillAmount)
        .multipliedBy(dataVouchers?.isPromo === 2 ? dataVouchers?.promoPrice : dataVouchers?.price)
        ?.toString()
    const { handleBuyVoucher } = useBuyVouchers(
        contractAddress,
        findTokenPayment?.token?.address,
        account,
        chainId,
        findTokenPayment?.token?.decimals,
        dataVouchers?.orderId?.toString(),
        Number(fillAmount),
    )

    const handleClick = async () => {
        setPendingBuyVoucher(!false)
        const { txHash } = await handleBuyVoucher()
        try {
            const res = await BrandApi.verify({
                transactionHash: txHash,
                chainId: chainId?.toString(),
                orderId: dataVouchers?.orderId?.toString(),
            })

            await dispatch(
                fetchBuyVouchers({
                    dataBuyVouchers: {
                        ...res?.data,
                    },
                }),
            )
            await setPendingBuyVoucher(false)
            await dispatch(fetchStatusScreen({ isActiveScreen: 2 }))
            toastSuccess('Quy đổi thành công. Vui lòng kiểm tra email nhận', <ToastDescriptionWithTx txHash={txHash} />)
        } catch (error) {
            console.log('error', error)
            toastError('Đã xảy ra lỗi', 'Gửi email thất bại.')
            setPendingBuyVoucher(false)
        } finally {
            setPendingBuyVoucher(false)
        }
    }

    const [infoPayment, setInfoPayment] = useState(null)
    useEffect(() => {
        (async () => {
            if (findTokenPayment?.isSupportedOnusApp) {
                try {
                    const res = await BrandApi.paymentOnus({
                        orderId: dataVouchers?.orderId?.toString(),
                    })
                    setInfoPayment(res?.data)
                } catch (error) {
                    console.log(error)
                }
            }
        })()
    }, [chainId, dataVouchers?.orderId, findTokenPayment?.isSupportedOnusApp])
    const [openModalPaymentOnus] = useModal(
        <ModalPaymentOnus title="Quét mã để quy đổi" ticketNumber={infoPayment?.ticketNumber} />,
    )

    return (
        <>
            <PageFullWidth>
                <Container width="100%" mb="1rem">
                    <Flex width="100%" flexDirection="column" style={{ gap: '1rem' }}>
                        <Flex width="100%">
                            <Flex
                                alignItems="center"
                                style={{ gap: '12px', cursor: 'pointer', width: 'fit-content' }}
                                onClick={() => {
                                    dispatch(fetchStatusScreen({ isActiveScreen: 0 }))
                                    dispatch(fetchIsUpdateOrder({ isUpdate: true }))
                                    router.push('/order')
                                }}
                            >
                                <ArrowLeftCircle width="32px" />
                                <Heading scale="lg">Quay lại</Heading>
                            </Flex>
                        </Flex>
                        <Flex width="100%" mt="1rem">
                            <Flex width="100%" justifyContent="center" alignItems="center" flexDirection="column">
                                <CsHeading scale="xl">Tóm tắt đơn hàng</CsHeading>
                                <CsSubHeading
                                    mt="1.5rem"
                                    onClick={() => {
                                        dispatch(fetchStatusScreen({ isActiveScreen: 0 }))
                                        dispatch(fetchIsUpdateOrder({ isUpdate: true }))
                                        router.push('/order')
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    Thay đổi thông tin
                                </CsSubHeading>
                            </Flex>
                        </Flex>

                        <Text mt="3rem" fontWeight="bold" fontSize={['16px', , '20px']}>
                            Thông tin người nhận quà
                        </Text>
                        <CsWrapInfo width="100%" alignItems="center" justifyContent="space-between">
                            <Flex width={['100%', , , '50%']} justifyContent="space-between">
                                <Text color="default">Số điện thoại:</Text>
                                <Text>{dataVouchers?.phoneNumber}</Text>
                            </Flex>
                            <Hr style={{ height: '30px', border: '1px solid #E5E5E5' }} />
                            <Flex width={['100%', , , '50%']} justifyContent="space-between">
                                <Text color="default">Email:</Text>
                                <Text>{dataVouchers?.email}</Text>
                            </Flex>
                        </CsWrapInfo>

                        <Text mt="1rem" fontWeight="bold" fontSize={['16px', , '20px']}>
                            Thông tin thẻ quà tặng
                        </Text>

                        <CsGiftCardInfoPC>
                            <CsFlexLine>
                                <RowItemHeading isFirst color="default">
                                    Tên sản phẩm
                                </RowItemHeading>
                                <RowItemHeading color="default">Số lượng</RowItemHeading>
                                <RowItemHeading color="default">Giá trị thẻ quà</RowItemHeading>
                                <RowItemHeading color="default">Tổng giá trị</RowItemHeading>
                            </CsFlexLine>
                            <CsFlexLine>
                                <RowItem isFirst>{dataVouchers?.nameProduct}</RowItem>
                                <RowItem>
                                    {Number(dataVouchers?.fillAmount).toLocaleString('en', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                    })}
                                </RowItem>
                                <RowItem>
                                    {dataVouchers?.isPromo === 2 ? (
                                        <>
                                            <Text fontSize={['14px', , '16px']}>
                                                {Number(dataVouchers?.promoPrice).toLocaleString('en', {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                })}
                                                {UNIT_TOKEN}
                                            </Text>
                                            <Text
                                                style={{
                                                    fontSize: '12px',
                                                    textDecoration: 'line-through',
                                                    color: '#9596a6',
                                                }}
                                            >
                                                {Number(dataVouchers?.price).toLocaleString('en', {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                })}
                                                {UNIT_TOKEN}
                                            </Text>
                                        </>
                                    ) : (
                                        <>
                                            <Text>
                                                {Number(dataVouchers?.price).toLocaleString('en', {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                })}
                                                {UNIT_TOKEN}
                                            </Text>
                                        </>
                                    )}
                                </RowItem>
                                <RowItem>
                                    {Number(totalPrice).toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})}{UNIT_TOKEN}
                                    { findTokenPayment?.token?.symbol !== "VNDC" &&
                                        <Text style={{fontSize:"10px"}}>
                                            Tương đương {formatNumberv2(findTokenPayment?.exchangeRate, findTokenPayment?.token?.symbol) } điểm {findTokenPayment?.token?.symbol}
                                        </Text>
                                    }
                                </RowItem>
                            </CsFlexLine>
                        </CsGiftCardInfoPC>

                        <CsGiftCardInfoMobile>
                            <Flex alignItems="flex-end" justifyContent="space-between">
                                <Text style={{ whiteSpace: 'nowrap' }} color="default">
                                    Tên sản phẩm
                                </Text>
                                <Text textAlign="right">{dataVouchers?.nameProduct}</Text>
                            </Flex>
                            <Flex alignItems="flex-end" justifyContent="space-between" mt="0.5rem">
                                <Text color="default">Số lượng</Text>
                                <Text textAlign="right">
                                    {Number(dataVouchers?.fillAmount).toLocaleString('en', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                    })}
                                </Text>
                            </Flex>
                            <Flex alignItems="flex-end" justifyContent="space-between" mt="0.5rem">
                                <Text color="default">Giá trị thẻ quà</Text>
                                <Text textAlign="right">
                                    {dataVouchers?.isPromo === 2 ? (
                                        <>
                                            <Text fontSize={['14px', , '16px']}>
                                                {Number(dataVouchers?.promoPrice).toLocaleString('en', {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                })}
                                                {UNIT_TOKEN}
                                            </Text>
                                            <Text
                                                style={{
                                                    fontSize: '10px',
                                                    textDecoration: 'line-through',
                                                    color: '#9596a6',
                                                }}
                                            >
                                                {Number(dataVouchers?.price).toLocaleString('en', {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                })}
                                                {UNIT_TOKEN}
                                            </Text>
                                        </>
                                    ) : (
                                        <>
                                            <Text>
                                                {Number(dataVouchers?.price).toLocaleString('en', {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                })}
                                                {UNIT_TOKEN}
                                            </Text>
                                        </>
                                    )}
                                </Text>
                            </Flex>

                            <Flex alignItems="flex-end" justifyContent="space-between" mt="0.5rem">
                                <Text color="default">Tổng giá trị</Text>
                                <Flex flexDirection="column">
                                <Text textAlign="right">
                                    {Number(totalPrice).toLocaleString('en', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                    })}
                                    {UNIT_TOKEN}
                                </Text>
                                { findTokenPayment?.token?.symbol !== "VNDC" &&
                                        <Text style={{fontSize:"10px"}}>
                                            Tương đương {formatNumberv2(findTokenPayment?.exchangeRate, findTokenPayment?.token?.symbol) } điểm {findTokenPayment?.token?.symbol}
                                        </Text>
                                }
                                </Flex>
                            </Flex>
                        </CsGiftCardInfoMobile>

                        <Text mt="1rem" fontWeight="bold" fontSize={['16px', , '20px']}>
                            Chọn hình thức quy đổi
                        </Text>
                        <Text mt="1rem" fontWeight="bold" fontSize={['14px', , '16px']} color="red">
                            *Lưu ý: Vui lòng không tải lại hoặc thoát trang web trong khi giao dịch đang được thực hiện
                        </Text>

                        <CsFlexCard width={['100%', , '70%']} my="1rem">
                            <Card>
                                <Flex
                                    flexDirection="column"
                                    alignItems="flex-start"
                                    justifyContent="flex-start"
                                    width="100%"
                                >
                                    <Text width="100%" className="textPoint" color="white">
                                        Điểm {findTokenPayment?.token?.symbol}
                                    </Text>

                                    <Flex
                                        width={['100%', , '85%']}
                                        alignItems="flex-end"
                                        flexDirection="row"
                                        justifyContent="space-between"
                                        style={{ gap: '14px' }}
                                    >
                                        <Text fontSize={['12px', , , '14px']} style={{ zIndex: 10 }} color="white">
                                            {getChainName(chainId)}:
                                        </Text>{' '}
                                        &nbsp;
                                        <Text fontSize={['12px', , , '14px']} style={{ zIndex: 10 }} color="white">
                                            {formatNumberv2(dataUser?.balanceOf, findTokenPayment?.token?.symbol)}{' '}
                                            {findTokenPayment?.token?.symbol}
                                        </Text>
                                    </Flex>
                                    {/* {
                                        ListBalance?.map((item) => {
                                            return(
                                                <Flex width={["100%", , "85%"]} alignItems="flex-end" flexDirection="row" justifyContent="space-between" style={{gap: '14px'}}>
                                                    <Text fontSize={['12px', , , '14px']} style={{zIndex:10}} color="white">{(item?.chainId === 97 || item?.chainId === 56) ? 'BNB Chain' : 'Onus Chain'}:</Text> &nbsp;
                                                    <Text fontSize={['12px', , , '14px']} style={{zIndex:10}} color="white">
                                                        { new BigNumber(item?.balanceOf).isNaN() ?
                                                            `0 VNDC`
                                                        :
                                                            `${new BigNumber(item?.balanceOf).decimalPlaces(0,1).toNumber().toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})} VNDC`
                                                        }
                                                        </Text>
                                                </Flex>
                                            )
                                        })
                                    } */}
                                </Flex>
                                <CsTagPrice>
                                    <TagPriceActiveFullWidth width="100%" />
                                </CsTagPrice>
                            </Card>
                        </CsFlexCard>

                        <Flex minWidth="40%" justifyContent="flex-start" alignItems="center" style={{ gap: '1rem' }}>
                            {!account ? (
                                <ConnectWalletButton>
                                    Kết nối ví
                                    <IconSort ml="4px" color="white" style={{ transform: 'rotate(270deg)' }} />
                                </ConnectWalletButton>
                            ) : (
                                <>
                                    {isNotAllowance ? (
                                        <CsButtonContinue
                                            onClick={handleApprove}
                                            style={{ cursor: 'pointer' }}
                                            disabled={pendingTx || isNotBanlance}
                                            endIcon={
                                                pendingTx ? (
                                                    <AutoRenewIcon spin color="white" />
                                                ) : (
                                                    <IconSort
                                                        ml="4px"
                                                        color="white"
                                                        style={{ transform: 'rotate(270deg)' }}
                                                    />
                                                )
                                            }
                                        >
                                            Chấp thuận
                                        </CsButtonContinue>
                                    ) : (
                                        <CsButtonContinue
                                            onClick={handleClick}
                                            disabled={isNotBanlance || pendingBuyVoucher}
                                            endIcon={
                                                pendingBuyVoucher ? (
                                                    <AutoRenewIcon color="white" spin />
                                                ) : (
                                                    <IconSort
                                                        ml="4px"
                                                        color="white"
                                                        style={{ transform: 'rotate(270deg)' }}
                                                    />
                                                )
                                            }
                                        >
                                            Quy đổi
                                        </CsButtonContinue>
                                    )}
                                </>
                            )}
                            {findTokenPayment?.isSupportedOnusApp && (
                                <>
                                    <Button onClick={openModalPaymentOnus}>Quy đổi qua Onus</Button>
                                </>
                            )}
                        </Flex>
                        {account && isNotBanlance && isLoading === false && (
                            <Text mt="0.5rem" color="red">
                                Số dư của bạn không đủ
                            </Text>
                        )}
                    </Flex>
                    {pendingBuyVoucher ? (
                        <>
                            <ModalV2 isOpen>
                                <WrapLoading>
                                    <div className="classic-4">
                                        <div className="loader" />
                                        <Text mt="1rem">Đang xử lý đơn hàng. Vui lòng không tải lại trang</Text>
                                    </div>
                                </WrapLoading>
                            </ModalV2>
                        </>
                    ) : (
                        ''
                    )}
                </Container>
            </PageFullWidth>
        </>
    )
}

const WrapLoading = styled.div`
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    .classic-4 {
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-weight: bold;
        height: 100%;
        width: 100%;
        font-size: 20px;
    }
    .loader {
        border: 14px solid #fff;
        border-top: 14px solid #01227a;
        border-radius: 50%;
        width: 80px;
        height: 80px;
        animation: spin 2s linear infinite;
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`
export default OrderSummary
